"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var cheerio = _interopRequireWildcard(require("cheerio"));

var _cheerioTableparser = _interopRequireDefault(require("cheerio-tableparser"));

var _axios = _interopRequireDefault(require("axios"));

var _jsBase = require("js-base64");

var _metaData = require("./metaData");

var _createSearchData = _interopRequireDefault(require("./createSearchData"));

var _cda = _interopRequireDefault(require("./cda.xsl"));

function sanitizeUnicodeText(text) {
  if (!text) return '';
  return text.replace(/[\u00A0\u2000-\u200A\u202F\u205F\u3000]/g, ' ').replace(/[\u180E\u200B\uFEFF]/g, '');
}

function loadXMLDoc(filename) {
  var xhttp;

  if (window.ActiveXObject) {
    xhttp = new window.ActiveXObject('Msxml2.XMLHTTP');
  } else {
    xhttp = new XMLHttpRequest();
  }

  xhttp.open('GET', filename, false);

  try {
    xhttp.responseType = 'msxml-document';
  } catch (err) {} // Helping IE11


  xhttp.send('');
  return xhttp.responseXML;
}

function getNodeText($, node) {
  var parts = $(node).contents().map(function (_, n) {
    if (n.type === 'text') return sanitizeUnicodeText(n.data.trim());

    if (n.type === 'tag') {
      if (n.name === 'br') return '\n';
      var text = getNodeText($, n);
      if (n.name === 'table' && text) text = "\n".concat(text.trim(), "\n");
      return text;
    }

    return '';
  }).get();
  return parts.filter(Boolean).join(' ');
}

function formatXMLDoc(xmlDoc) {
  var xml = loadXMLDoc(xmlDoc);
  var xsl = loadXMLDoc(_cda.default);
  var xsltProcessor = new XSLTProcessor();
  xsltProcessor.importStylesheet(xsl);
  var resultDocument = xsltProcessor.transformToFragment(xml, document);
  return resultDocument;
}

var flattenNestedTables = function flattenNestedTables($, table) {
  $(table).find('td').each(function (_, td) {
    var nestedTables = $(td).find('table');
    if (nestedTables.length) $(td).html(getNodeText($, td));
  });
  return table;
};

var parseDocument = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(document) {
    var xmlDocumentStr, getPlainContent, res, b64, dataUrl, transformed, transformedHtmlStr, $, metaData, body, sections, attachments, searchData;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (document) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            getPlainContent = function getPlainContent($, str) {
              if (!str) return '';

              if (/[<&]/gi.test(str)) {
                try {
                  return getNodeText($, "<div>".concat(str, "</div>"));
                } catch (e) {}
              }

              return sanitizeUnicodeText(str.trim());
            };

            if (!document.startsWith('/static')) {
              _context.next = 17;
              break;
            }

            _context.prev = 4;
            _context.next = 7;
            return _axios.default.get(document, {
              'Content-Type': 'application/xml'
            });

          case 7:
            res = _context.sent;
            xmlDocumentStr = res.data;
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            console.dir(_context.t0);
            return _context.abrupt("return");

          case 15:
            _context.next = 18;
            break;

          case 17:
            xmlDocumentStr = document;

          case 18:
            b64 = _jsBase.Base64.encode(xmlDocumentStr);
            dataUrl = "data:text/xml;base64,".concat(b64);
            transformed = formatXMLDoc(dataUrl);
            transformedHtmlStr = new XMLSerializer().serializeToString(transformed); // const blob = new Blob([transformedHtmlStr], { type: 'text/html' });
            // fileDownload(blob, 'result.html');

            $ = cheerio.load(transformedHtmlStr); // Cheerio Table parser extension

            (0, _cheerioTableparser.default)($);
            metaData = (0, _metaData.extractMetaDataFromCDA)(xmlDocumentStr);
            /**
             * Document Body
             */

            body = [];
            sections = $('div[class="container-fluid header"]').toArray();
            sections.forEach(function (_section) {
              var section = {
                title: '',
                data: []
              };
              var sectionTitle = $(_section).find('h1[class="section-title"]').text();
              section.title = sectionTitle;
              var sectionBody = $(_section).find('div[class="section-text"]');
              var sectionContents = $(sectionBody).contents().toArray();

              var parseTable = function parseTable(node) {
                var table = flattenNestedTables($, node);
                var tableHead = $(table).find('> thead');

                if (!tableHead.length) {
                  var tableContent = getNodeText($, table);
                  var paragraphs = tableContent.split(/\n{2,}/).filter(function (p) {
                    return sanitizeUnicodeText(p.trim());
                  });
                  paragraphs.forEach(function (paragraph) {
                    section.data.push({
                      type: 'paragraph',
                      content: sanitizeUnicodeText(paragraph.trim())
                    });
                  });
                } else {
                  (function () {
                    var columns, data;
                    var parsedTableData = $(table).parsetable(false, false, false);
                    columns = parsedTableData.map(function (node) {
                      return node[0];
                    }).filter(function (col) {
                      return !!col;
                    }).map(function (col, index) {
                      return getPlainContent($, col) || "Column ".concat(index + 1);
                    });
                    data = [];
                    var tableDataWithoutColumnName = parsedTableData.map(function (arr) {
                      return arr.slice(1);
                    });
                    var idx = 0;
                    var max = tableDataWithoutColumnName[0].length;

                    var _loop = function _loop() {
                      var row = {};
                      columns.forEach(function (col) {
                        var colIdx = columns.indexOf(col);
                        row[col] = getPlainContent($, tableDataWithoutColumnName[colIdx][idx]);
                      });
                      data.push(row);
                      idx++;
                    };

                    while (idx < max) {
                      _loop();
                    }

                    var formattedData = data.map(function (row) {
                      var newRow = {};
                      Object.entries(row).forEach(function (_ref2) {
                        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                            key = _ref3[0],
                            value = _ref3[1];

                        newRow[key] = getPlainContent($, value);
                      });
                      return newRow;
                    }); // console.log('formattedData:: ', formattedData);

                    section.data.push({
                      type: 'table',
                      content: {
                        columns: columns,
                        data: formattedData
                      }
                    });
                  })();
                }
              };

              var parseAndAddContent = function parseAndAddContent(node) {
                if (!node) return null;

                if (node.type !== 'text' && node.name !== 'table') {
                  var nodeContents = $(node).contents().toArray();
                  nodeContents.forEach(function (_node) {
                    return parseAndAddContent(_node);
                  });
                } else if (node.type === 'text' || node.name === 'br') {
                  var content = sanitizeUnicodeText($(node).find('br').replaceWith('\n').end().text().trim());
                  var paragraphs = content.split(/\n{2,}/).filter(function (p) {
                    return sanitizeUnicodeText(p.trim());
                  }); // Add each paragraph as a separate entry

                  paragraphs.forEach(function (paragraph) {
                    section.data.push({
                      type: 'paragraph',
                      content: sanitizeUnicodeText(paragraph.trim())
                    });
                  });
                } else if (node.name === 'table') {
                  parseTable(node);
                }
              };

              sectionContents.forEach(function (node) {
                return parseAndAddContent(node);
              });

              if (section.title) {
                body.push(section);
              }
            });
            attachments = [];
            searchData = (0, _createSearchData.default)(body);
            return _context.abrupt("return", {
              header: metaData,
              body: body,
              searchData: searchData,
              attachments: attachments
            });

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));

  return function parseDocument(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _default = parseDocument;
exports.default = _default;